<template>
  <b-input-group>
    <template #prepend>
      <b-input-group-text>
        <i class="fa fa-search fa-fw"></i>
      </b-input-group-text>
    </template>
    <b-input
      v-model="query"
      :class="{
        'empty': !query
      }"
      placeholder="Search all Tasks"
      type="text"
    ></b-input>
    <template
      v-if="query"
      #append
    >
      <b-input-group-text
        @click="clearSearch()"
      >
        <i class="fa fa-close fa-fw"></i>
      </b-input-group-text>
    </template>
  </b-input-group>
</template>

<style type="scss" scoped>
.input-group-text {
  background-color: #fff;
}
input[type="search"] {
  border-left: 0;
  padding-left: 0;
}

input[type="search"]:not(.empty) {
  border-right: 0 !important;
}
</style>

<script>
import { debounce } from 'lodash'

export default {
  data () {
    return {
      query: ''
    }
  },
  watch: {
    query: debounce(function() {
      this.search(this.query)
    }, 300),
    '$route' (to, from) {
      if (from.name === 'tasks.search' && to.name !== 'tasks.search') {
        this.clearSearch()
      } else if (to.name === 'tasks.search') {
        this.query = to.query.q
      }
    }
  },
  mounted () {
    this.query = this.$route.query.q
  },
  methods: {
    clearSearch () {
      this.query = ''

       let location = {
          name: 'tasks.today',
          params: {
            userId: this.$route.params.userId
          }
        }

      this.$router.push(location)
    },
    search (query) {
      if (query) {
        let location = {
          name: 'tasks.search',
          params: {
            userId: this.$route.params.userId
          },
          query: {
            q: query
          }
        }
        this.$router.push(location)
      }
    }
  }
}
</script>